module.exports = __webpack_public_path__ + "img/reactivate.69fcafed.svg";